import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import GUI from 'lil-gui'

/**
 * Base
 */
// Debug
const gui = new GUI()

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene();

scene.background = new THREE.Color('#fff');

/**
 * Test cube
 */
const cube = new THREE.Mesh(
    new THREE.BoxGeometry(1, 1, 1),
    new THREE.MeshStandardMaterial({
        color: '#ff0000',
        roughness: 0.5,
        metalness: 0.5,
        opacity: 0.5,
        transparent: true
    })
)
scene.add(cube)


// Floor
const floor = new THREE.Mesh(
    new THREE.PlaneGeometry(20, 20),
    new THREE.MeshStandardMaterial({
        // map: grassColorTexture,
        // aoMap: grassAmbientOcclusionTexture,
        // normalMap: grassNormalTexture,
        // roughnessMap: grassRoughnessTexture
        color: '#fff'
    })
)
floor.rotation.x = - Math.PI * 0.5
floor.position.y = -0.5

const floorFolder = gui.addFolder('Floor')
floorFolder.add(floor.position, 'x').min(- 5).max(5).step(0.001).name('x')
floorFolder.add(floor.position, 'y').min(- 5).max(5).step(0.001).name('y')
floorFolder.add(floor.position, 'z').min(- 5).max(5).step(0.001).name('z')
scene.add(floor)


/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.position.x = 3
camera.position.y = 3
camera.position.z = 3
scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

/**
 * Lights
 */

const ambientLight = new THREE.AmbientLight('#b9d5ff', 0.25)
gui.add(ambientLight, 'intensity').min(0).max(1).step(0.001)
scene.add(ambientLight);

const spotLight = new THREE.SpotLight('#00ff00', 1)
spotLight.position.set(2, 1, 0)
const folder = gui.addFolder('Directional Light')
    folder.add(spotLight, 'intensity').min(0).max(1).step(0.001).name('intensity')
    folder.add(spotLight.position, 'x').min(- 5).max(5).step(0.001).name('x')
    folder.add(spotLight.position, 'y').min(- 5).max(5).step(0.001).name('y')
    folder.add(spotLight.position, 'z').min(- 5).max(5).step(0.001).name('z')
scene.add(spotLight);


// Shadow
renderer.shadowMap.enabled = true
renderer.shadowMap.type = THREE.PCFShadowMap
spotLight.castShadow = true
cube.castShadow = true
floor.receiveShadow = true

/**
 * Animate
 */
const clock = new THREE.Clock()

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()

    // Update controls
    controls.update()

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()